import React from 'react';
import ReactDOM, { render } from 'react-dom';
import App from './app';

export const init = ({ 
  selector = 'myAliceWebChat', 
  color='#999',
  channel='wa',
  text = '',
  theme = 'dark',
  radius='20px',
  position='right',
  mx='20px',
  mb='20px',
  z='99999',
  number='8801749945055',
  boxShadow='none',
  message=''
 }) => {
  ReactDOM.render(
    <App 
      text={text} 
      color={color}
      theme={theme}
      radius={radius}
      position={position}
      mx={mx}
      mb={mb}
      z={z}
      channel={channel}
      number={number}
      message={message}
      boxShadow={boxShadow}
    />, document.getElementById(selector)
  );
};